module.exports = __webpack_public_path__ + "img/jian.0d5d7b69.png";